import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 4 }

import { reactive, computed, ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import { listByParamCodes } from '@/api/common'
import { businessStatusEnum, orderTypeEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import type { ParamCodeItem } from '@/typings/common'
import { businessList, businessDelete, businessDetails } from '@/api/overseasSales/chanceManage'
import { BusinessParams, BusinessListItem } from '@/typings/api/chanceManage'
import { useInteractionStore } from '@/stores/interaction'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'DcCosOFbuBusiness' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()
const { t } = useI18n()

// 商机状态枚举
const statusEnum = computed(() => {
  const list = businessStatusEnum.map((item) => ({
    name: t(item.lang),
    value: item.value,
    color: item.color
  }))
  return list
})
const paramCodeData = ref<{
  ofbu_chance_type: ParamCodeItem[]
  ofbu_head_competitors: ParamCodeItem[]
  ofbu_warehouse: ParamCodeItem[]
  ofbu_head_domestic_warehouse: ParamCodeItem[]
  ofbu_demand_info: ParamCodeItem[]
  ofbu_head_replenish_method: ParamCodeItem[]
  ofbu_currency: ParamCodeItem[]
  ofbu_shipments: ParamCodeItem[]
}>({
  ofbu_chance_type: [], // 商机类型
  ofbu_head_competitors: [], // 头程竞争对手
  ofbu_warehouse: [], // 尾程竞争对手（目前合作海外仓）
  ofbu_head_domestic_warehouse: [], // 国内仓库
  ofbu_demand_info: [], // 区域仓(需求海外仓参数)
  ofbu_head_replenish_method: [], // 运输方式
  ofbu_currency: [], // 币种
  ofbu_shipments: [] // 发货量
})
const shareInfo = useInteractionStore()
const eumns = {
  'en-US': 'enName',
  'zh-CN': 'cnName'
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [
      'ofbu_chance_type',
      'ofbu_head_competitors',
      'ofbu_warehouse',
      'ofbu_head_domestic_warehouse',
      'ofbu_demand_info',
      'ofbu_head_replenish_method',
      'ofbu_currency',
      'ofbu_shipments'
    ]
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
onMounted(() => getByParamCodes())
const tableRef = ref()
const queryForm = reactive<BusinessParams>({ dataType: 'all', timeType: 0 })
const columns = computed(() => [
  { title: t('business.pehfv5'), dataIndex: 'saleChanceName', fixed: 'left', width: 190 },
  { title: t('business.7y5c89'), dataIndex: 'customerName', width: 200 },
  { title: t('business.udlavq'), dataIndex: 'saleChanceRefId' },
  { title: t('business.nnrhea'), dataIndex: 'arkCode' },
  { title: t('business.u21f2s'), dataIndex: 'id' },
  { title: t('business.ptwqaa'), dataIndex: 'customerNumber' },
  { title: t('business.kolh0f'), dataIndex: 'currency', dicData: paramCodeData.value.ofbu_currency },
  { title: t('business.t3fsg4'), dataIndex: 'shipments', dicData: paramCodeData.value.ofbu_shipments },
  { title: t('business.me6p1g'), dataIndex: 'headDestinationCountryWarehouse', dicData: paramCodeData.value.ofbu_demand_info },
  { title: t('business.7xsihs'), dataIndex: 'status' },
  { title: t('business.tw4fv1'), dataIndex: 'avgMonthlySalesCurrency', dicData: paramCodeData.value.ofbu_currency },
  { title: t('business.ts2f2s'), dataIndex: 'avgMonthlyOrder' },
  { title: t('business.sj39ks'), dataIndex: 'firstInboundDate' },
  { title: t('business.sasd32'), dataIndex: 'firstTransactionDate' },
  { title: t('business.l6hwus'), dataIndex: 'dutyByName' },
  { title: t('common.remark'), dataIndex: 'remark' },
  { title: t('common.createByName'), dataIndex: 'createByName' },
  { title: t('common.createTime'), dataIndex: 'createTime', width: 190 },
  { title: t('business.dp8n8j'), dataIndex: 'updateTime', width: 190 },
  {
    title: t('common.action'),
    dataIndex: 'action',
    langWidth: {
      zh: 180,
      en: 220
    },
    fixed: 'right'
  }
])
const getCustomLink = (row:any) => {
  if (row && row.stage === 2) {
    return `/ofbu/potential/view?cosId=${row.saleChanceRefId}`
  }
  if (row && row.stage === 3) {
    return `/ofbu/contract/view?cosId=${row.saleChanceRefId}`
  }
  if (row && row.stage === 4) {
    return `/ofbu/clients/view?cosId=${row.saleChanceRefId}`
  }
  return ''
}
const getList = (queryForm: BusinessParams, callBack: (res: any) => void) => {
  businessList(queryForm).then((res) => {
    callBack(res)
  })
}
const showMask = (record: BusinessListItem, callBack: (res: any) => void) => {
  businessDetails({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}
/// 用来匹配商机名字的区域仓名
const getDemandInfoName = (headDestinationId?: number) => {
  const find = paramCodeData.value.ofbu_demand_info?.find((item) => item.id === headDestinationId)
  if (find) {
    return find[eumns[shareInfo.language]] ?? find.name
  }
  return headDestinationId || ''
}
const handleTabsChange = (val: any) => {
  queryForm.dataType = val
  if (val === 'me' && queryForm.dutyByList) {
    queryForm.dutyByList = undefined
  }
  tableRef.value?.search()
}
// 新增编辑函数
const triggerAddOrEdit = (id?: number) => {
  if (id) {
    router.push({ path: '/ofbu/business/edit', query: { id } })
  } else {
    router.push('/ofbu/business/add')
  }
}
const handleDelete = (row: BusinessListItem) => {
  Modal.delete({
    name: row.saleChanceNameByTxt,
    onOk() {
      businessDelete({ id: row.id }).then(() => {
        message.success(t('business.bp7zke'))
        tableRef.value?.delFetch()
      })
    }
  })
}
// 跳转写跟进页面
const handleWriteFollowUp = (cosId: string, chanceId: string) => {
  router.push({
    path: '/ofbu/followUpRecord/add',
    query: { followRefId: cosId, chanceId, returnPath: route.fullPath }
  })
}
/**
 * 竞争对手序列化
 * @param orderType 订单类型
 * @param arr 对手数组
 */
const competitorFormat = (orderType: number, arr: any) => {
  if (!Array.isArray(arr) || !arr?.length) return '--'
  const hasOrderType = orderTypeEnum.find((e) => e.value === orderType)
  if (!hasOrderType) return arr
  const listEnum = orderType === 1 ? paramCodeData.value.ofbu_head_competitors : paramCodeData.value.ofbu_warehouse
  const result: string[] = []
  arr.forEach((ele) => {
    const item = listEnum.find((e) => e.id === ele)
    if (item) result.push(item[eumns[shareInfo.language]] || (item.name as string))
  })
  return result.join('、')
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_tabs, {
            activeKey: queryForm.dataType,
            "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.dataType) = $event)),
            onChange: handleTabsChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tab_pane, {
                key: "all",
                tab: _unref(t)('common.all')
              }, null, 8, ["tab"]),
              _createVNode(_component_a_tab_pane, {
                key: "me",
                tab: _unref(t)('business.e1svrf')
              }, null, 8, ["tab"]),
              _createVNode(_component_a_tab_pane, {
                key: "subUser",
                tab: _unref(t)('business.97srub')
              }, null, 8, ["tab"])
            ]),
            _: 1
          }, 8, ["activeKey"]),
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: queryForm,
            "onUpdate:search": _cache[12] || (_cache[12] = ($event: any) => ((queryForm) = $event)),
            onFetch: getList,
            onMask: showMask,
            ref_key: "tableRef",
            ref: tableRef,
            rowKey: "id",
            tableId: "DcCosOFbuBusiness"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "status",
                    label: _unref(t)('business.7xsihs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: queryForm.statusList,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.statusList) = $event)),
                        options: _unref(businessStatusEnum),
                        mode: "multiple",
                        placeholder: _unref(t)('common.pleaseSelect'),
                        allowClear: ""
                      }, null, 8, ["value", "options", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: _unref(t)('business.7y5c89')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.customerName) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('business.nnrhea')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.arkCode,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.arkCode) = $event)),
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  (queryForm.dataType !== 'me')
                    ? (_openBlock(), _createBlock(_component_dc_form_item, {
                        key: 0,
                        name: "dutyByList",
                        label: _unref(t)('business.l6hwus')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UserSelect, {
                            value: queryForm.dutyByList,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.dutyByList) = $event)),
                            allowClear: "",
                            mode: "multiple"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_dc_form_item, {
                    name: "headDestinationCountryWarehouseList",
                    label: _unref(t)('business.me6p1g')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        value: queryForm.headDestinationCountryWarehouseList,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.headDestinationCountryWarehouseList) = $event)),
                        mode: "multiple",
                        options: paramCodeData.value.ofbu_demand_info,
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "timeType",
                    label: _unref(t)('business.uv0uo4')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: queryForm.timeType,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.timeType) = $event)),
                            style: {"width":"33%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('business.wwys5u')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('business.dp8n8j')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 2 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('business.sj39ks')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 3 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('business.sasd32')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createVNode(_component_CosRangePicker, {
                            isOutputBeijingTime: "",
                            startTime: queryForm.startTime,
                            "onUpdate:startTime": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.startTime) = $event)),
                            endTime: queryForm.endTime,
                            "onUpdate:endTime": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.endTime) = $event)),
                            style: {"width":"67%"}
                          }, null, 8, ["startTime", "endTime"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "saleChanceRefId",
                    label: _unref(t)('business.udlavq')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.saleChanceRefId,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.saleChanceRefId) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "id",
                    label: _unref(t)('business.u21f2s')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.id,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.id) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        allowClear: "",
                        placeholder: _unref(t)('common.pleaseInput')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (triggerAddOrEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                ]),
                _: 1
              })), [
                [_directive_permission, 'ofbu_business_add_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_ofbu",
                taskType: "407",
                search: queryForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.export')), 1)
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'ofbu_business_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'saleChanceName')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: '/ofbu/business/view?id=' + record.id
                  }, {
                    default: _withCtx(() => [
                      (record.arkCode)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (record.headDestinationCountryWarehouse)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(`${record.arkCode}+${getDemandInfoName(record.headDestinationCountryWarehouse)}`), 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(record.arkCode), 1))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (record.headDestinationCountryWarehouse)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(getDemandInfoName(record.headDestinationCountryWarehouse)), 1))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("--")
                                ], 64))
                          ], 64))
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'customerName')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: getCustomLink(record),
                    class: "ant-table-cell-ellipsis",
                    title: text
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(text || '--'), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "title"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'status')
                ? (_openBlock(), _createBlock(_component_dc_status, {
                    key: 2,
                    enums: statusEnum.value,
                    value: text
                  }, null, 8, ["enums", "value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === '$currency')
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(`${record.planSaleAmount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${text}`), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === '$avgMonthlySalesCurrency')
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(record.avgMonthlySales
                  ? `${record.avgMonthlySales?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${text}`
                  : '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (handleWriteFollowUp(record.saleChanceRefId, record.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('btn.writeFollow')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'ofbu_business_write_follow_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                      type: "link",
                      onClick: ($event: any) => (triggerAddOrEdit(record.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'ofbu_business_edit_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (handleDelete(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'ofbu_business_del_btn']
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})